import React from 'react';

const SidebarAd = () => {
  return (
    <div className="sidebar-ad hidden md:block w-[120px] h-full bg-white p-2 sticky top-0">
      <iframe
        border="0"
        src="https://www.trip.com/partners/ad/SB5632888?Allianceid=6648580&SID=228113005&trip_sub1="
        style={{ width: '120px', height: '600px' }}
        frameBorder="0"
        scrolling="no"
        id="SB5632888"
      ></iframe>
    </div>
  );
};

export default SidebarAd;